import { useI18n } from '../i18n'

export function ImpressumPage() {
  const { t } = useI18n()
  return (
    <div className="mx-auto max-w-2xl px-4 py-12">
      <h1 className="mb-6 text-2xl font-bold text-text">{t('footer.impressum')}</h1>
      <div className="prose prose-invert text-text-muted space-y-4 text-sm leading-relaxed">
        <p className="text-text font-semibold">Angaben gemaess &sect; 5 TMG</p>
        <p>
          Joey Masterlevel<br />
          Musterstrasse 1<br />
          12345 Musterstadt<br />
          Deutschland
        </p>
        <p>
          <strong className="text-text">Kontakt:</strong><br />
          E-Mail: jav@masterlevel.de
        </p>
        <p className="text-xs opacity-60">
          Verantwortlich fuer den Inhalt nach &sect; 55 Abs. 2 RStV: siehe oben.
        </p>
      </div>
    </div>
  )
}
